import * as React from 'react';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { AppDispatch } from '../../../app/store';
import { currentModality } from '../../../features/modality/modalitySlice';
import { itemLookup, itemForm, itemData } from '../../../features/operation/thunks/itemThunk';
import { security } from '../../../features/security/thunks/securityThunk';

import Theme from '../../themes/Theme'

import { DefaultButton, Stack, StackItem } from '@fluentui/react';
import Teeth, { TeethState } from './Body';

type DentalChartProps = {
    controller: string,
    name: string,
    value: string[],
    state?: TeethState[],
    selectionMode?: 'none' | 'single' | 'multiple'
    onInit?: (name: string | undefined, value: string[], required?: boolean | undefined) => void,
    onChange?: (name: string | undefined, value: string[], required?: boolean | undefined) => void,
    required?: boolean,
    readOnly?: boolean,
    children?: { name: string, lookup: string, controller: string, required?: boolean, defaultValue?: any }[],
    parentController?: string,
    isFemale?: boolean
}

export default (props: DentalChartProps) => {
    const dispatch: AppDispatch = useDispatch();
    const modality = useSelector(currentModality)

    const securityContext = useSelector(security)
    let token = securityContext?.credential?.token

    const iForm = useSelector(itemForm)
    const iData = useSelector(itemData);
    const dItem = iData.find(d => d.key === props.controller)?.value

    const [selected, setSelected] = useState(props.value ?? [])
    const [buttonState, setButtonState] = useState({
        tlb: {
            index: (props.isFemale
                ? ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23"]
                : ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23"]
            ), selected: false },
    })

    useEffect(() => {
        setSelected(props.value ?? [])
        if (props.onInit) {
            props.onInit(props.name, props.value ?? [], props.required)
        }
    }, [props.value])

    useEffect(() => {
        if (props.selectionMode === "none") {
            return
        }

        const newButtonState: any = { ...buttonState }
        for (let key in newButtonState) {
            newButtonState[key].selected = true
            newButtonState[key].index.forEach((tooth: string) => selected?.indexOf(tooth) === -1 ? newButtonState[key].selected = false : {})
        }
        setButtonState(newButtonState)

        if (props.onChange)
            props.onChange(props.name, selected, props.required)

    }, [selected])

    const selectToothGroup = (value: any) => {
        if (props.selectionMode === "none") {
            return
        }

        let newSelected = [] as string[]

        if (props.selectionMode === "single") {
            newSelected = value.selected ? [] : value.index;

        } else if (value.selected) {
            newSelected = selected?.filter(item => !value.index.includes(item))
        }
        else {
            const unfilterSelected = selected.concat(value.index).sort()
            newSelected = unfilterSelected.filter((item, index) => unfilterSelected.indexOf(item) === index)
        }

        setSelected(newSelected ?? [])

        dispatchToChildren(newSelected)
    }

    const onTeethSelectionChange = (name: string, value: string[], required?: boolean | undefined) => {
        if (props.selectionMode === "none") {
            return
        }

        setSelected(value ?? [])

        dispatchToChildren(value)
    }

    const dispatchToChildren = (newValue: string[]) => {
        let parentItemForm: any = {}
        let parentItemData: any = {}
        let parentItemPage: any = {}

        if (props.children && (modality === "item" || modality === "new")) {
            if (props.parentController) {
                parentItemForm = iForm.find(i => i.key === props.parentController)?.value
                parentItemData = iData.find(d => d.key === props.parentController)?.value

                if (parentItemData?.metadata?.page) {
                    Object.assign(parentItemPage, parentItemData?.metadata?.page)

                    if (parentItemPage.index > 0) {
                        parentItemPage.index = parentItemPage.index - 1
                    } else {
                        parentItemPage.index = 0
                    }
                }
            }

            const form = iForm.find(i => i.key === props.controller)?.value
            const page = dItem?.metadata?.page

            const body = {
                form: {
                    ...form, [props.name]: newValue
                },
                parent: {
                    form: { ...parentItemForm },
                    page: parentItemPage
                }, page: page
            }

            props.children.forEach((c) => {
                dispatch(itemLookup({ controller: c.controller, target: c.name, lookup: c.lookup, body: body, token: token }))
                if (props.onChange)
                    props.onChange(c.name, c.defaultValue ?? [], c.required ?? false)
            })
        }
    }

    return <>
        <Stack horizontalAlign="center">
            <Stack horizontal>
                <Stack>
                    <Teeth name={props.name} selectionMode={props.selectionMode} isFemale={props.isFemale} value={selected} state={props.state} onChange={onTeethSelectionChange} />
                </Stack>
            </Stack>
            <Stack horizontalAlign="center">
                <StackItem><DefaultButton text="tutto il corpo" style={{ margin: "3px 0" }} onClick={() => selectToothGroup({ index: ( ["24"] ), selected: false },)} styles={{ root: { backgroundColor: buttonState.tlb.selected ? Theme.fluent.palette.themeLight : Theme.fluent.palette.white } }}></DefaultButton></StackItem>
            </Stack>
        </Stack>
    </>
}